import React, {useState, useEffect} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import PopupDeleteDataset from '../../dataset/popup/popupDeleteDataset';
import GlobalState, {changepopupdataset, changepopupdeleteDataset, changeActivePortraits, addportraits, changeportraitflag, changesegmentationpage, changepopuprefreshDataset, changepopuprefreshDatasetcsv, adddataset, cleardataset, changedatasetflag, minusnumpagesdatasets, plusnumpagesdatasets, changedatasettottal} from "../../../stores/GlobalState";
import Pool from "../../autorize/UserPool";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"
const Sidebar = observer(() => {
    
   
    async function getDataPortraits()
    {
       
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `portraits/tables`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            //cleardataset();
            // if(data&&data.items.length>0)
            // {
            //     data.items?.map((n, id)=>
            //         {
                       
            //             var dataset = {
            //                 id: n.id,
            //                 name: n.name,
            //                 source: n.source,
            //                 last_changes: n.upload_time,
            //                 rows: n.rowsCount,
            //                 columns: n.columnsCount,
            //                 object_ID: n.objectId,
            //                 used_in_models: n.usedInModels,
            //                 file_key: n.id,
            //                 file_name: n.file_name,
            //                 key_column: n.objectId,
            //                 status: n.status,
            //                 upload_time: n.upload_time,
            //                 uploadedAt: n.uploadedAt,
            //                 user_id: n.user_id,
            //                 columnNames: n.columnNames,
            //                 tag: n.tag
            //             }
                        
            //             addportraits(dataset);
            //             return "";
            //         }
                    
            //     )
            // }

            changesegmentationpage(1)
            getDataPortrait();
        }
        else
        {
            changesegmentationpage(1)
        }
    }
    async function getDataPortrait()
    {
       
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `portraits/table?page=1&limit=10`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            changeActivePortraits(data);
            changesegmentationpage(2)

        }
        else
        {
            changesegmentationpage(1)
        }
    }
    const minusnumpagesmodels0 = () =>{
        minusnumpagesdatasets();
        getDataAttach();
    }
    const plusnumpagesmodels0= () =>{
        plusnumpagesdatasets();
        getDataAttach();
    }
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    if(GlobalState.portraitflag==0){ 
        getDataPortraits();
        changeportraitflag(1);
    }
   
    const deleteDataset = (n, id) =>{

       
        setdeleteId(n)
        setdeleteIdnum(id)
        changepopupdeleteDataset(n, id);
        
       
    }
    const refreshDataset = (n, id) =>{
        console.log("test")
        changepopuprefreshDataset(n, id);
        
    }
    const refreshDatasetcsv = (n, id) =>{
        console.log("test")
        changepopuprefreshDatasetcsv(n, id);
        
    }
    const changesegmentationpage0 = () =>{
        changesegmentationpage(1)
    }
    return (
        <>
        <div className="segment datasets" >
           
            <div className='header-segment dataset newlistdataset'>
                <div className='title_dataset_list'>
                    <div className='left_title_dataset_list'>
                       
                        
                    </div>
                    <div className='right_title_dataset_list' style={{marginRight: "100px"}}>
                        
                        <div className='filters' onClick={()=>refreshDataset(0, "")}>
                            <span className='tooltipe'>
                                Only BigQuery datasets can be refreshed; CSV files need to be updated manually.
                            </span>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="#020203"/>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='datasethead'>
                    <div className='topfield field1 filtras'>
                        {langv?.dataset?.main?.text11}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field2 filtras'>
                        {langv?.dataset?.main?.text3}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field8 filtras'>
                        Tag
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field3 filtras'>
                        {langv?.dataset?.main?.text4}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field4 filtras'>
                        {langv?.dataset?.main?.text5}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field5 filtras'>
                        {langv?.dataset?.main?.text6}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field6 filtras'>
                        {langv?.dataset?.main?.text7}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className='topfield field7 filtras'>
                        {langv?.dataset?.main?.text8}
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.75 5.83398H16.25M5.83333 10.0007H14.1667M8.33333 14.1673H11.6667" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                {
                    
                    GlobalState.portraits?.map((n, id)=>
                        
                        <div className='datasetbody new_datasetbody' onClick={()=>changesegmentationpage0()}>
                            
                            
                            <div className='topfield field1' >
                                <input
                                    id="dataset"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.name}
                                    //onChange={(event) => setDataset(event.target.value)}
                                />


                            </div>
                            <div className='topfield field2'>
                                <input
                                    id="source"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.source}
                                    //onChange={(event) => setSource(event.target.value)}
                                />
                            </div>
                            <div className='topfield field8'>
                                <div className='tags_dataset'>
                                    
                                    {
                                        n.tag.length>0?
                                            n.tag=="Predict input"?
                                            <span style={{background: "rgba(251, 227, 209, 1)"}}>{n.tag}</span>
                                            :
                                            n.tag=="Predict output"?
                                            <span style={{background: "rgba(214, 239, 244, 1)"}}>{n.tag}</span>
                                            :
                                            n.tag=="Portrait"?
                                            <span style={{background: "rgba(253, 243, 215, 1)"}}>{n.tag}</span>
                                            :
                                            <span>{n.tag}</span>
                                            :
                                            <></>
                                    }
                                    
                                    {/* <span>Training</span>
                                    <span>Portrait</span>
                                    <span>Prediction input</span> */}
                                </div>
                            </div>
                            <div className='topfield field3'>
                                <input
                                    id="lastchanges"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.uploadedAt}
                                    //onChange={(event) => setLastchanges(event.target.value)}
                                />
                            </div>
                            <div className='topfield field4'>
                                <input
                                    id="rows"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.rows?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                                    //onChange={(event) => setRows(event.target.value)}
                                />
                            </div>
                            <div className='topfield field5'>
                                <input
                                    id="columns"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.columns}
                                    //onChange={(event) => setColumns(event.target.value)}
                                />
                            </div>
                            <div className='topfield field6'>
                                <input
                                    id="objectid"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.object_ID}
                                    //onChange={(event) => setObjectid(event.target.value)}
                                />
                            </div>
                            <div className='topfield field7'>
                                <input
                                    id="usedinmodels"
                                    type="text"
                                    disabled="true"
                                    placeholder=""
                                    className="pop-input"
                                    value={n.used_in_models}
                                    //onChange={(event) => setUsedinmodels(event.target.value)}
                                />
                            </div>
                            <div className='tolatipa_block'>
                                {
                                    GlobalState.ispopuprefreshDatasetnum!=n.id?
                                    <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.6875 5.41406C10.6875 5.76216 10.8258 6.096 11.0719 6.34214C11.3181 6.58828 11.6519 6.72656 12 6.72656C12.3481 6.72656 12.6819 6.58828 12.9281 6.34214C13.1742 6.096 13.3125 5.76216 13.3125 5.41406C13.3125 5.06597 13.1742 4.73213 12.9281 4.48598C12.6819 4.23984 12.3481 4.10156 12 4.10156C11.6519 4.10156 11.3181 4.23984 11.0719 4.48598C10.8258 4.73213 10.6875 5.06597 10.6875 5.41406ZM10.6875 11.9766C10.6875 12.3247 10.8258 12.6585 11.0719 12.9046C11.3181 13.1508 11.6519 13.2891 12 13.2891C12.3481 13.2891 12.6819 13.1508 12.9281 12.9046C13.1742 12.6585 13.3125 12.3247 13.3125 11.9766C13.3125 11.6285 13.1742 11.2946 12.9281 11.0485C12.6819 10.8023 12.3481 10.6641 12 10.6641C11.6519 10.6641 11.3181 10.8023 11.0719 11.0485C10.8258 11.2946 10.6875 11.6285 10.6875 11.9766ZM10.6875 18.5391C10.6875 18.8872 10.8258 19.221 11.0719 19.4671C11.3181 19.7133 11.6519 19.8516 12 19.8516C12.3481 19.8516 12.6819 19.7133 12.9281 19.4671C13.1742 19.221 13.3125 18.8872 13.3125 18.5391C13.3125 18.191 13.1742 17.8571 12.9281 17.611C12.6819 17.3648 12.3481 17.2266 12 17.2266C11.6519 17.2266 11.3181 17.3648 11.0719 17.611C10.8258 17.8571 10.6875 18.191 10.6875 18.5391Z" fill="black"/>
                                    </svg>
                                    :
                                    <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20.8C14.3339 20.8 16.5722 19.8729 18.2225 18.2225C19.8729 16.5722 20.8 14.3339 20.8 12C20.8 9.66609 19.8729 7.42778 18.2225 5.77746C16.5722 4.12714 14.3339 3.2 12 3.2C9.66609 3.2 7.42778 4.12714 5.77746 5.77746C4.12714 7.42778 3.2 9.66609 3.2 12C3.2 14.3339 4.12714 16.5722 5.77746 18.2225C7.42778 19.8729 9.66609 20.8 12 20.8ZM10.828 14.558L16.637 8.75L17.485 9.599L11.535 15.549C11.3475 15.7365 11.0932 15.8418 10.828 15.8418C10.5628 15.8418 10.3085 15.7365 10.121 15.549L7 12.426L7.849 11.577L10.829 14.557L10.828 14.558Z" fill="#34C759"/>
                                    </svg>
                                }
                                
                                
                                <div className='tolatipa'>
                                    {
                                        n.source=="bigquery"?
                                        <span onClick={()=>refreshDataset(n.id, n.name)} className='ref_tooltip'>
                                            <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.8">
                                                <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                </g>
                                            </svg>
                                            Refresh
                                        </span>
                                        :
                                        <span onClick={()=>refreshDatasetcsv(n.id, n.name)} className='ref_tooltip'>
                                            <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.8">
                                                <path d="M12.0588 4.50001C8.49128 4.50001 5.55928 7.22587 5.27352 10.7011H4.55838C4.44774 10.701 4.33957 10.7339 4.24762 10.7954C4.15568 10.857 4.08411 10.9445 4.042 11.0468C3.99989 11.1491 3.98914 11.2617 4.01113 11.3701C4.03311 11.4786 4.08683 11.578 4.16547 11.6559L5.41566 12.8956C5.52018 12.9992 5.6614 13.0574 5.80857 13.0574C5.95575 13.0574 6.09697 12.9992 6.20149 12.8956L7.45168 11.6559C7.53032 11.578 7.58404 11.4786 7.60602 11.3701C7.62801 11.2617 7.61726 11.1491 7.57515 11.0468C7.53304 10.9445 7.46147 10.857 7.36953 10.7954C7.27758 10.7339 7.16941 10.701 7.05877 10.7011H6.39423C6.67701 7.85022 9.10149 5.61625 12.0588 5.61625C13.0338 5.61437 13.993 5.86261 14.8447 6.33725C15.6964 6.81188 16.4121 7.49704 16.9234 8.32723C16.9608 8.39165 17.0107 8.44793 17.0702 8.49275C17.1297 8.53757 17.1976 8.57002 17.2698 8.5882C17.3421 8.60637 17.4172 8.6099 17.4909 8.59857C17.5645 8.58725 17.6351 8.56129 17.6986 8.52224C17.762 8.4832 17.817 8.43184 17.8603 8.37121C17.9035 8.31058 17.9342 8.24189 17.9506 8.1692C17.9669 8.09652 17.9685 8.0213 17.9553 7.94798C17.9421 7.87467 17.9143 7.80474 17.8737 7.74232C17.2626 6.74991 16.4072 5.93077 15.3893 5.36314C14.3714 4.7955 13.2242 4.49833 12.0588 4.50001ZM18.5791 10.6148C18.4747 10.5116 18.3338 10.4538 18.1869 10.4538C18.0401 10.4538 17.8992 10.5116 17.7948 10.6148L16.5394 11.8546C16.4605 11.9323 16.4066 12.0318 16.3844 12.1403C16.3623 12.2488 16.3729 12.3614 16.415 12.4639C16.457 12.5663 16.5286 12.6539 16.6206 12.7156C16.7126 12.7772 16.8208 12.8101 16.9316 12.8101H17.6006C17.3163 15.6602 14.8836 17.8949 11.9122 17.8949C10.9341 17.8974 9.9717 17.6496 9.11654 17.1749C8.26138 16.7002 7.54196 16.0146 7.02677 15.1832C6.98826 15.1208 6.93785 15.0666 6.8784 15.0237C6.81894 14.9808 6.75162 14.95 6.68028 14.9331C6.60893 14.9162 6.53495 14.9135 6.46257 14.9252C6.39019 14.9369 6.32082 14.9627 6.25842 15.0012C6.1324 15.079 6.04244 15.2036 6.00832 15.3477C5.9742 15.4918 5.99871 15.6436 6.07647 15.7696C6.69171 16.763 7.55098 17.5824 8.57247 18.1498C9.59396 18.7172 10.7437 19.0138 11.9122 19.0111C15.4901 19.0111 18.4348 16.2875 18.7213 12.8101H19.4416C19.5523 12.8101 19.6606 12.7772 19.7526 12.7156C19.8446 12.6539 19.9162 12.5663 19.9582 12.4639C20.0002 12.3614 20.0109 12.2488 19.9887 12.1403C19.9666 12.0318 19.9126 11.9323 19.8338 11.8546L18.5791 10.6148Z" fill="black"/>
                                                </g>
                                            </svg>
                                            Refresh
                                        </span>
                                    }
                                    
                                    <span className='del_tooltip' onClick={()=>deleteDataset(n.id, id)}>
                                        <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.8">
                                            <path d="M10.4 6.8H13.6C13.6 6.37565 13.4314 5.96869 13.1314 5.66863C12.8313 5.36857 12.4243 5.2 12 5.2C11.5757 5.2 11.1687 5.36857 10.8686 5.66863C10.5686 5.96869 10.4 6.37565 10.4 6.8ZM9.2 6.8C9.2 6.4323 9.27242 6.0682 9.41314 5.72849C9.55385 5.38877 9.7601 5.08011 10.0201 4.8201C10.2801 4.5601 10.5888 4.35385 10.9285 4.21314C11.2682 4.07242 11.6323 4 12 4C12.3677 4 12.7318 4.07242 13.0715 4.21314C13.4112 4.35385 13.7199 4.5601 13.9799 4.8201C14.2399 5.08011 14.4461 5.38877 14.5869 5.72849C14.7276 6.0682 14.8 6.4323 14.8 6.8H19.4C19.5591 6.8 19.7117 6.86321 19.8243 6.97574C19.9368 7.08826 20 7.24087 20 7.4C20 7.55913 19.9368 7.71174 19.8243 7.82426C19.7117 7.93679 19.5591 8 19.4 8H18.344L17.408 17.6888C17.3362 18.4312 16.9904 19.1202 16.4381 19.6215C15.8859 20.1227 15.1666 20.4003 14.4208 20.4H9.5792C8.83349 20.4001 8.11448 20.1224 7.56236 19.6212C7.01024 19.1199 6.66459 18.431 6.5928 17.6888L5.656 8H4.6C4.44087 8 4.28826 7.93679 4.17574 7.82426C4.06321 7.71174 4 7.55913 4 7.4C4 7.24087 4.06321 7.08826 4.17574 6.97574C4.28826 6.86321 4.44087 6.8 4.6 6.8H9.2ZM10.8 10.6C10.8 10.4409 10.7368 10.2883 10.6243 10.1757C10.5117 10.0632 10.3591 10 10.2 10C10.0409 10 9.88826 10.0632 9.77574 10.1757C9.66321 10.2883 9.6 10.4409 9.6 10.6V16.6C9.6 16.7591 9.66321 16.9117 9.77574 17.0243C9.88826 17.1368 10.0409 17.2 10.2 17.2C10.3591 17.2 10.5117 17.1368 10.6243 17.0243C10.7368 16.9117 10.8 16.7591 10.8 16.6V10.6ZM13.8 10C13.9591 10 14.1117 10.0632 14.2243 10.1757C14.3368 10.2883 14.4 10.4409 14.4 10.6V16.6C14.4 16.7591 14.3368 16.9117 14.2243 17.0243C14.1117 17.1368 13.9591 17.2 13.8 17.2C13.6409 17.2 13.4883 17.1368 13.3757 17.0243C13.2632 16.9117 13.2 16.7591 13.2 16.6V10.6C13.2 10.4409 13.2632 10.2883 13.3757 10.1757C13.4883 10.0632 13.6409 10 13.8 10ZM7.7872 17.5736C7.83035 18.0189 8.0378 18.4322 8.36909 18.7329C8.70039 19.0336 9.1318 19.2001 9.5792 19.2H14.4208C14.8682 19.2001 15.2996 19.0336 15.6309 18.7329C15.9622 18.4322 16.1697 18.0189 16.2128 17.5736L17.1392 8H6.8608L7.7872 17.5736Z" fill="#FF3B30"/>
                                            </g>
                                        </svg>
                                        Delete
                                    </span>

                                </div>
                            </div>
                           

                        </div>
                    )
                }
                
            </div>
        </div>
        <div className='pagination_line'>
            <div className='countpagepagination'>
                {langv?.dataset?.main?.text9}  {GlobalState.datasetstottal>0?(GlobalState.numpagesdatasets*1-1)*8+1:"0"} -&nbsp;
                
                {
                    GlobalState.numpagesdatasets*8<GlobalState.datasetstottal?
                    GlobalState.numpagesdatasets*8
                    :
                    GlobalState.datasetstottal
                }
                 &nbsp;of {GlobalState.datasetstottal} {langv?.dataset?.main?.text10} 
            </div>
        
            <div className='pagination pagdatasets'>
                {
                    GlobalState.numpagesdatasets<2?
                    <div className='arrowP cursorenone' >

                        <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.1">
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            </g>
                        </svg>

                        


                    </div>
                    :
                    <div className='arrowP' onClick={()=>minusnumpagesmodels0()}>
                        <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.4">
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            </g>
                        </svg>

                        <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117361)"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                            <defs>
                            <linearGradient id="paint0_linear_3491_117361" x1="1" y1="13" x2="45" y2="13" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F5C538"/>
                            <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>
                }
                
                <div className='pagenum'>

                    {
                        GlobalState.datasetstottal<8?
                        <span>01</span>: 
                        GlobalState.numpagesdatasets<8?
                        <span>{"0"+GlobalState.numpagesdatasets}</span>
                        :GlobalState.numpagesdatasets
                    }
                    / 
                    {
                        GlobalState.datasetstottal<8?
                        "01":
                        Math.ceil(GlobalState.datasetstottal/8)<8?
                        "0"+Math.ceil(GlobalState.datasetstottal/8):
                        Math.ceil(GlobalState.datasetstottal/8)
                    }
                </div>
                
                    {
                        GlobalState.datasetstottal<8?
                        <div className='arrowP cursorenone'>
                            <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.1">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                </g>
                            </svg>
                        </div>
                        :
                        GlobalState.numpagesdatasets==Math.ceil(GlobalState.datasetstottal/8)?
                        <div className='arrowP cursorenone'>
                            <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.1">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                </g>
                            </svg>
                        </div>
                        :
                        <div className='arrowP' onClick={()=>plusnumpagesmodels0()}>
                            <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.4">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                </g>
                            </svg>
                            <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117355)"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                <defs>
                                <linearGradient id="paint0_linear_3491_117355" x1="53" y1="13" x2="10" y2="13" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F5C538"/>
                                <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                                </linearGradient>
                                </defs>
                            </svg>
                        </div>

                    }
                    
                
            </div>
        </div>
        {/* {GlobalState.ispopupdeleteDatasetShow ?<PopupDeleteDataset id={{deleteId}} deleteIdnum = {{deleteIdnum}}/>:<></>} */}
        </>
    );
})

export default Sidebar;
